// Reducers
import { myStore } from "App";
import { setRects } from "~/reducers";
import { toggleVisibilidadeAvatarExecucao, posicionarAvatarExecucao, restaurarAvatarsExecucao } from "~/actions/avatarsActions";
import { setExecuting } from "~/actions/nodes";

// Passo numero 3 (PASSO3)
// Criar uma nova função no arquivo nodeFunctions.js, use de exemplo a função MostrarFunction, que ja lida com o Palco de execução

export const EsperarFunction = async ({ node }) => {
    const tempo = parseFloat(node.from.data.inputValue) * 1000;
    console.log(`Esperando ${node.from.data.inputValue} segundos...`);
    await new Promise((resolve) => setTimeout(resolve, tempo));
};

export const LerFunction = async ({ node }) => {
    // Show single message balloon for input
    const rects = myStore.getState().rects.rects;
    const { mensagem, tipo = 'texto', variavel } = node.from.data;
    const variaveis = myStore.getState().variaveis;
    // tipo: 'texto' ou 'logico'

    // Replace all {{var}} markers with variable values in the message
    const mensagemProcessada = String(mensagem || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, varName) => {
        const match = variaveis.find(v => v.nome === varName);
        return match ? match.valor : `{{${varName}}}`;
    });

    // Cria o retângulo principal para mensagem e input
    const mainRect = {
        id: `ler-${node.from.id}`,
        x: 0,
        y: -100, // Invertido para aparecer abaixo do centro
        text: mensagemProcessada,
        visible: true,
        tipo,
        variavel,
    };
    // Cria o retângulo do botão OK
    const confirmRect = {
        id: `confirm-ler-${node.from.id}`,
        x: 0,
        y: -180, // Invertido para aparecer abaixo do input
        text: 'OK',
        visible: true,
        isButton: true,
    };
    // Adiciona ambos ao estado
    const newRects = rects.concat(mainRect, confirmRect);
    myStore.dispatch(setRects(newRects));

    // Função para atualizar o valor do input (simulação, pois depende do Stage/Canvas)
    let inputValue = '';
    let inputChecked = null;
    // Listener para input customizado (deve ser disparado pelo Stage/Canvas)
    const inputHandler = (e) => {
        if (e.type === 'inputLer' && e.detail?.rectId === mainRect.id) {
            if (tipo === 'logico') {
                inputChecked = e.detail.value; // true/false
            } else {
                inputValue = e.detail.value;
            }
        }
    };
    window.addEventListener('inputLer', inputHandler);

    // Aguarda confirmação do usuário
    await new Promise((resolve) => {
        const handler = (e) => {
            if (e.type === 'clickConfirm' && e.detail?.rectId === confirmRect.id) {
                window.removeEventListener('clickConfirm', handler);
                window.removeEventListener('inputLer', inputHandler);
                resolve();
            }
        };
        window.addEventListener('clickConfirm', handler);
    });

    // Remove os retângulos após confirmação
    const filteredRects = myStore.getState().rects.rects.filter((r) =>
        ![mainRect.id, confirmRect.id].includes(r.id)
    );
    myStore.dispatch(setRects(filteredRects));

    // Armazena o valor na variável global (Redux)
    let valorFinal = tipo === 'logico' ? inputChecked : inputValue;
    if (variavel) {
        // Busca índice da variável pelo nome
        const variaveis = myStore.getState().variaveis;
        const idx = variaveis.findIndex(v => v.nome === variavel);
        if (idx !== -1) {
            myStore.dispatch({ type: 'ATUALIZAR_VARIAVEL', payload: { index: idx, campo: 'valor', valor: valorFinal } });
        }
    }
    console.log(`Valor lido (${variavel}):`, valorFinal);
};

export const MostrarFunction = async ({ node }) => {
    const rects = myStore.getState().rects.rects;
    const { inputValue, mode = 'confirm', displayDuration = 3, holdExecution = false } = node.from.data;
    const variaveis = myStore.getState().variaveis;
    // Replace all {{var}} markers with variable values
    const valorParaMostrar = String(inputValue).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, varName) => {
        const match = variaveis.find(v => v.nome === varName);
        return match ? match.valor : `{{${varName}}}`;
    });

    const newRect = {
        id: `node-${node.from.id}`,
        x: 0,
        y: -100, // Invertido para aparecer abaixo do centro
        text: valorParaMostrar,
        visible: true,
    };

    const newRects = rects.concat(newRect);
    myStore.dispatch(setRects(newRects));
    console.log(`Mostrando mensagem: ${valorParaMostrar}`);

    const hideBalloon = (id) => {
        const filteredRects = myStore.getState().rects.rects.filter((rect) =>
            rect.id !== id
        );
        myStore.dispatch(setRects(filteredRects));
    };

    if (mode === 'confirm') {
        // Exibe botão de confirmação como outro retângulo
        const confirmRect = {
            id: `confirm-${node.from.id}`,
            x: 0,
            y: -160, // Invertido para aparecer abaixo da mensagem
            text: 'OK',
            visible: true,
        };
        const withConfirm = newRects.concat(confirmRect);
        myStore.dispatch(setRects(withConfirm));
        // Aguarda evento customizado clickConfirm com detail.rectId
        await new Promise((resolve) => {
            const handler = (e) => {
                if (e.type === 'clickConfirm' && e.detail?.rectId === confirmRect.id) {
                    window.removeEventListener('clickConfirm', handler);
                    resolve();
                }
            };
            window.addEventListener('clickConfirm', handler);
        });
        // Remove os retângulos após confirmação
        const filteredRects = myStore.getState().rects.rects.filter((r) =>
            ![newRect.id, confirmRect.id].includes(r.id)
        );
        myStore.dispatch(setRects(filteredRects));
    } else if (mode === 'time') {
        const ms = displayDuration * 1000;
        // Esconder após tempo definido
        setTimeout(() => hideBalloon(newRect.id), ms);
        // Segurar execução se marcado
        if (holdExecution) {
            await new Promise((res) => setTimeout(res, ms));
        }
    }
};

export const DecidirFunction = async ({ node, edges }) => {
    try {
        // Evaluate decision expression using expression tree
        const result = evaluateExpressionTree(node.from.data.dropData);

        // Log the decision expression and result
        const { type: opType, data: exprData } = node.from.data.dropData;
        
        // Melhor logging para debug
        console.log(`🔍 DecidirFunction - Operador: ${opType}`);
        console.log(`📊 Dados completos:`, JSON.stringify(exprData, null, 2));
        console.log(`✅ Resultado da decisão: ${result}`);

        const nextEdge = edges.find((edge) =>
            result
                ? edge.sourceHandle === "verdadeiro" && edge.source === node.from.id
                : edge.sourceHandle === "falso" && edge.source === node.from.id
        );

        return nextEdge?.target || null;
    } catch (error) {
        console.error('❌ Erro na DecidirFunction:', error.message);
        // Em caso de erro, vai para falso como fallback
        const falseEdge = edges.find((edge) => 
            edge.sourceHandle === "falso" && edge.source === node.from.id
        );
        return falseEdge?.target || null;
    }
};

const operatorFunctions = {
    'Igual a': (l, r) => l == r,
    'Diferente de': (l, r) => l != r,
    'Diferente': (l, r) => l != r, // Compatibilidade
    'Maior que': (l, r) => toNumber(l, 'esquerda') > toNumber(r, 'direita'),
    'Menor que': (l, r) => toNumber(l, 'esquerda') < toNumber(r, 'direita'),
    'Maior ou igual': (l, r) => toNumber(l, 'esquerda') >= toNumber(r, 'direita'),
    'Maior ou igual a': (l, r) => toNumber(l, 'esquerda') >= toNumber(r, 'direita'), // Compatibilidade
    'Menor ou igual': (l, r) => toNumber(l, 'esquerda') <= toNumber(r, 'direita'),
    'Menor ou igual a': (l, r) => toNumber(l, 'esquerda') <= toNumber(r, 'direita'), // Compatibilidade
    'Soma': (l, r) => toNumber(l, 'esquerda') + toNumber(r, 'direita'),
    'Subtração': (l, r) => toNumber(l, 'esquerda') - toNumber(r, 'direita'),
    'Multiplicação': (l, r) => toNumber(l, 'esquerda') * toNumber(r, 'direita'),
    'Divisão': (l, r) => {
        const left = toNumber(l, 'esquerda');
        const right = toNumber(r, 'direita');
        return right !== 0 ? left / right : (console.warn('Divisão por zero!'), Infinity);
    },
    'Potenciação': (l, r) => Math.pow(toNumber(l, 'base'), toNumber(r, 'expoente')),
    'Radiciação': (index, radicand) => Math.pow(toNumber(radicand, 'radicando'), 1 / toNumber(index, 'índice')),
    'Conjunção/Interseção': (l, r) => toBoolean(l, 'esquerda') && toBoolean(r, 'direita'),
    'Disjunção inclusiva/União': (l, r) => toBoolean(l, 'esquerda') || toBoolean(r, 'direita'),
    'Negação/complementação': (v) => !toBoolean(v, 'valor'),
    'Disjunção exclusiva': (l, r) => toBoolean(l, 'esquerda') !== toBoolean(r, 'direita')
};

const toNumber = (value, label = 'valor') => {
    if (typeof value === 'number' && !Number.isNaN(value)) return value;
    if (typeof value === 'boolean') return value ? 1 : 0;

    const normalized = value?.toString?.().trim().replace(',', '.');
    const parsed = parseFloat(normalized);
    if (Number.isNaN(parsed)) {
        throw new Error(`Valor ${label} inválido: "${value}" não é numérico`);
    }
    return parsed;
};

const toBoolean = (value, label = 'valor') => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;

    const s = value?.toString?.().trim().toLowerCase();
    if (s === 'true' || s === 'verdadeiro' || s === 'v' || s === '1' || s === 'sim' || s === 's') return true;
    if (s === 'false' || s === 'falso' || s === 'f' || s === '0' || s === 'nao' || s === 'não' || s === 'n') return false;

    throw new Error(`Valor ${label} inválido: "${value}" não é lógico (use true/false, verdadeiro/falso, 1/0)`);
};

export const evaluateExpressionTree = (dropData) => {
    try {
        if (!dropData) {
            throw new Error('Expressão vazia');
        }

        console.log("evaluateExpressionTree", dropData);
        const variaveis = myStore.getState().variaveis;

        const getLeafValue = (node) => {
            console.log("getValueInside", node);
            
            // Verifica se o node existe
            if (!node) {
                console.error("❌ Node undefined em getValue");
                throw new Error("Expressão incompleta: um dos valores não foi definido");
            }
            
            // Verifica se node tem a estrutura esperada
            if (!node.data) {
                console.error("❌ Node.data undefined:", node);
                throw new Error("Expressão mal formada: dados do node não encontrados");
            }
            
            // Se é um operador aninhado, avalia recursivamente
            if (node.type) {
                return evaluateExpressionTree(node);
            }
            
            const val = node.data.value;
            
            // Nova lógica: Se é uma variável identificada pelos metadados
            if (node.data.isVariable && node.data.variableName) {
                const varObj = variaveis.find(v => v.nome === node.data.variableName);
                if (!varObj) throw new Error(`Variável "${node.data.variableName}" não encontrada`);
                console.log(`🟢 Variável ${node.data.variableName} =`, varObj.valor);
                return varObj.valor;
            }
            
            // Lógica antiga: Se for formato {{variavel}} (compatibilidade)
            const varMatch = val && val.match ? val.match(/\{\{(.+?)\}\}/) : null;
            if (varMatch) {
                const varName = varMatch[1];
                const varObj = variaveis.find(v => v.nome === varName);
                if (!varObj) throw new Error(`Variável "${varName}" não encontrada`);
                console.log(`🟢 Variável ${varName} =`, varObj.valor);
                return varObj.valor;
            }
            
            // Se for nome direto de variável (compatibilidade com sistema antigo)
            const varObj = variaveis.find(v => v.nome === val);
            if (varObj) {
                console.log(`🟢 Variável ${val} =`, varObj.valor);
                return varObj.valor;
            }
            
            if (val === undefined || val === null || val === '') {
                throw new Error('Valor não definido');
            }

            // Valor literal (mantém como string/boolean/etc; coerção acontece no operador)
            return val;
        };

        // Permite folha (valor simples/variável) diretamente
        if (!dropData.type) {
            return getLeafValue({ data: dropData.data || {} });
        }

        const { type, data } = dropData;
        
        console.log("getValueOutside", data);
        
        // Verifica se data existe
        if (!data) {
            throw new Error("Dados da expressão não encontrados");
        }
        
        let leftValue, rightValue;
        
        // Para diferentes tipos de operadores com estruturas específicas
        if (type === 'Potenciação' && data.baseDrop && data.exponentDrop) {
            leftValue = getLeafValue(data.baseDrop);
            rightValue = getLeafValue(data.exponentDrop);
        } else if (type === 'Radiciação' && data.indexDrop && data.radicandDrop) {
            leftValue = getLeafValue(data.indexDrop); // índice da raiz
            rightValue = getLeafValue(data.radicandDrop); // radicando
        } else if (type === 'Negação/complementação' && data.valueDrop) {
            leftValue = getLeafValue(data.valueDrop);
        } else if (data.leftDrop && data.rightDrop) {
            leftValue = getLeafValue(data.leftDrop);
            rightValue = getLeafValue(data.rightDrop);
        } else {
            throw new Error(`Estrutura de dados incompatível para operador ${type}`);
        }
        
        console.log("leftValue", leftValue);
        console.log("rightValue", rightValue);
        console.log(`🔍 Comparação: ${leftValue} ${type} ${rightValue}`);
        
        const opFunc = operatorFunctions[type];
        if (!opFunc) throw new Error(`Operador ${type} não suportado`);
        
        const resultado = type === 'Negação/complementação' ? opFunc(leftValue) : opFunc(leftValue, rightValue);
        console.log(`✅ Resultado da operação: ${resultado}`);
        
        return resultado;
        
    } catch (error) {
        console.error("❌ Erro ao avaliar expressão:", error.message);
        throw error; // Re-throw para ser capturado pela função chamadora
    }
};

// Função de atribuição: avalia expressão e atualiza variável
export const AtribuirFunction = async ({ node }) => {
    try {
        const { variavel, dropData } = node.from.data;
        
        if (!variavel) {
            const error = "❌ ERRO: Nenhuma variável foi selecionada para atribuição";
            console.error(error);
            alert(`${error}\n\nPor favor, selecione uma variável antes de executar.`);
            return;
        }
        
        if (!dropData) {
            const error = "❌ ERRO: Nenhuma expressão foi definida para atribuição";
            console.error(error);
            alert(`${error}\n\nPor favor, configure uma expressão antes de executar.`);
            return;
        }
        
        let newValue;
        
        // Se é apenas um valor simples digitado (sem operador)
        if (!dropData.type && dropData.data && dropData.data.value !== undefined) {
            newValue = dropData.data.value;
            console.log(`📝 Valor simples digitado: "${newValue}"`);
        }
        // Se é uma expressão complexa (com operadores ou variáveis)
        else if (dropData.type) {
            newValue = evaluateExpressionTree(dropData);
            console.log(`🧮 Resultado da expressão: ${newValue}`);
        }
        // Se não há valor nem tipo definido
        else {
            const error = "❌ ERRO: Nenhum valor foi definido para atribuição";
            console.error(error);
            alert(`${error}\n\nPor favor, digite um valor ou arraste uma expressão antes de executar.`);
            return;
        }
        
        // Find the variable and update it
        const variaveis = myStore.getState().variaveis;
        const varIndex = variaveis.findIndex(v => v.nome === variavel);
        const varName = variavel;

        if (varIndex >= 0) {
            console.log(`✅ Atribuindo: ${varName} = ${newValue}`);
            myStore.dispatch({ type: 'ATUALIZAR_VARIAVEL', payload: { index: varIndex, campo: 'valor', valor: newValue } });
        } else {
            const error = `❌ ERRO: Variável "${varName}" não encontrada`;
            console.error(error);
            alert(`${error}\n\nA variável pode ter sido removida durante a execução.`);
        }
        
    } catch (error) {
        const errorMessage = `❌ ERRO DE ATRIBUIÇÃO: ${error.message}`;
        console.error(errorMessage);
        alert(`${errorMessage}\n\nVerifique se todas as variáveis têm valores numéricos válidos e se a expressão está completa.`);
    }
};

export const VirarFunction = async ({ node }) => {
    console.log("=== EXECUTANDO VIRAR AVATAR ===");
    const { selectedAvatar, graus, direcao } = node.from.data;
    console.log("Dados do nó:", { selectedAvatar, graus, direcao });
    
    const avatars = myStore.getState().avatars;
    console.log("Avatares disponíveis:", avatars.length);
    
    const avatarIndex = parseInt(selectedAvatar);
    if (isNaN(avatarIndex) || avatarIndex < 0 || avatarIndex >= avatars.length) {
        console.error("Índice de avatar inválido para virar:", avatarIndex);
        return;
    }

    const avatar = avatars[avatarIndex];
    console.log("Avatar selecionado:", avatar);
    
    const grausNumerico = parseFloat(graus);
    
    if (isNaN(grausNumerico)) {
        console.error("Valor de graus inválido:", graus);
        return;
    }

    // Calcula a nova rotação baseada na direção
    const rotacaoAtual = avatar.rotacao || 0;
    let novaRotacao;
    
    if (direcao === 'esquerda') {
        novaRotacao = rotacaoAtual - grausNumerico;
    } else {
        novaRotacao = rotacaoAtual + grausNumerico;
    }

    // Normaliza a rotação para ficar entre 0 e 360 graus
    novaRotacao = ((novaRotacao % 360) + 360) % 360;

    console.log(`Avatar "${avatar.nome}" virando ${grausNumerico}° para a ${direcao}. Rotação: ${rotacaoAtual}° → ${novaRotacao}°`);

    // Atualiza a rotação do avatar
    myStore.dispatch({
        type: 'ATUALIZAR_AVATAR',
        payload: {
            index: avatarIndex,
            campo: 'rotacao',
            valor: novaRotacao
        }
    });
    
    console.log("=== DISPATCH REALIZADO ===");
    
    // Verifica o estado após a atualização
    const avatarsAposAtualizacao = myStore.getState().avatars;
    console.log("Estado do avatar após atualização:", avatarsAposAtualizacao[avatarIndex]);
};

export const AvatarVisivelFunction = async ({ node }) => {
    const { selectedAvatar, acao } = node.from.data;
    
    console.log('🎯 AvatarVisivelFunction executada');
    console.log('📊 Dados do nó:', { selectedAvatar, acao, allData: node.from.data });
    
    if (selectedAvatar === undefined || selectedAvatar === "") {
        console.error("❌ Avatar não selecionado");
        return;
    }

    if (!acao) {
        console.error("❌ Ação não definida - provavelmente nó não foi configurado corretamente");
        return;
    }

    const avatarIndex = parseInt(selectedAvatar);
    const avatars = myStore.getState().avatars;
    
    if (avatarIndex < 0 || avatarIndex >= avatars.length) {
        console.error("❌ Índice de avatar inválido:", avatarIndex);
        return;
    }

    const avatar = avatars[avatarIndex];
    const novaVisibilidade = acao === "mostrar";
    
    console.log(`🎭 ${acao === "mostrar" ? "Mostrando" : "Ocultando"} avatar "${avatar.nome}" (índice ${avatarIndex})`);
    console.log(`📊 Estado anterior: visivel=${avatar.visivel}, visivelInicial=${avatar.visivelInicial}`);
    console.log(`🔄 Nova visibilidade: ${novaVisibilidade}`);
    
    // Atualiza a visibilidade do avatar usando ação de execução
    myStore.dispatch(toggleVisibilidadeAvatarExecucao(avatarIndex, novaVisibilidade));
    
    console.log('✅ AvatarVisivelFunction concluída');
};

export const AvatarPosicionarFunction = async ({ node }) => {
    const { selectedAvatar, x, y } = node.from.data;
    
    if (selectedAvatar === undefined || selectedAvatar === "") {
        console.error("Avatar não selecionado");
        return;
    }

    const avatarIndex = parseInt(selectedAvatar);
    const avatars = myStore.getState().avatars;
    
    if (avatarIndex < 0 || avatarIndex >= avatars.length) {
        console.error("Índice de avatar inválido");
        return;
    }

    const avatar = avatars[avatarIndex];
    
    console.log(`Posicionando avatar "${avatar.nome}" em (${x*10}, ${y*10})`);
    
    // Atualiza a posição do avatar usando ação de execução
    myStore.dispatch(posicionarAvatarExecucao(avatarIndex, x*10 || 0, y*10 || 0));
};

export const InteragirAvatarFunction = async ({ node }) => {
    const { selectedAvatar, tipoBalao, posicaoBalao, mensagem, modoExibicao, tempoExibicao, armazenarResposta, nomeVariavel, tipoResposta } = node.from.data;
    
    if (!selectedAvatar || selectedAvatar === "") {
        console.error("Avatar não selecionado para interação");
        return;
    }

    const avatarIndex = parseInt(selectedAvatar);
    const avatars = myStore.getState().avatars;
    
    if (avatarIndex < 0 || avatarIndex >= avatars.length) {
        console.error("Índice de avatar inválido para interação");
        return;
    }

    const avatar = avatars[avatarIndex];
    console.log(`Avatar "${avatar.nome}" ${tipoBalao}: "${mensagem}" (posição: ${posicaoBalao})`);
    
    // Calcula a posição do balão baseada na seleção e tamanho do avatar
    const calcularPosicaoBalao = (avatarX, avatarY, avatarTamanho, posicao) => {
        const offset = 60; // Distância base do avatar
        const raioAvatar = (avatarTamanho || 50) / 2; // Raio do avatar
        const distanciaTotal = offset + raioAvatar; // Distância total considerando o tamanho
        
        switch(posicao) {
            case "acima":
                return { x: avatarX, y: avatarY + distanciaTotal }; // Invertido: acima agora é +Y
            case "abaixo":
                return { x: avatarX, y: avatarY - distanciaTotal }; // Invertido: abaixo agora é -Y
            case "esquerda":
                return { x: avatarX - distanciaTotal, y: avatarY };
            case "direita":
                return { x: avatarX + distanciaTotal, y: avatarY };
            case "acima-esquerda":
                return { 
                    x: avatarX - (distanciaTotal * 0.7), 
                    y: avatarY + (distanciaTotal * 0.7) // Invertido
                };
            case "acima-direita":
                return { 
                    x: avatarX + (distanciaTotal * 0.7), 
                    y: avatarY + (distanciaTotal * 0.7) // Invertido
                };
            case "abaixo-esquerda":
                return { 
                    x: avatarX - (distanciaTotal * 0.7), 
                    y: avatarY - (distanciaTotal * 0.7) // Invertido
                };
            case "abaixo-direita":
                return { 
                    x: avatarX + (distanciaTotal * 0.7), 
                    y: avatarY - (distanciaTotal * 0.7) // Invertido
                };
            default:
                return { x: avatarX, y: avatarY + distanciaTotal }; // padrão: acima (invertido)
        }
    };
    
    const posicao = calcularPosicaoBalao(avatar.x || 0, avatar.y || 0, avatar.tamanho, posicaoBalao || "acima");
    
    // Posição do botão OK sempre abaixo do avatar (considerando eixo Y invertido)
    const posicaoOK = {
        x: avatar.x || 0,
        y: (avatar.y || 0) - ((avatar.tamanho || 50) / 2) - 30 // Invertido: abaixo agora é -Y
    };
    
    // Define o tipo de balão baseado na seleção
    let tipoRect;
    switch(tipoBalao) {
        case "pensar":
            tipoRect = "thought";
            break;
        case "perguntar":
            tipoRect = "input";
            break;
        case "dizer":
        default:
            tipoRect = "speech";
            break;
    }
    
    // Se é uma pergunta e deve armazenar resposta, cria balão de entrada
    if (tipoBalao === "perguntar" && armazenarResposta === "sim") {
        const rects = myStore.getState().rects.rects;
        const mainRect = {
            id: `interagir-${node.from.id}`,
            x: posicao.x,
            y: posicao.y,
            text: mensagem,
            visible: true,
            tipo: tipoResposta || 'texto',
            variavel: nomeVariavel,
            balloonType: "input", // Tipo especial para entrada de dados
            balloonPosition: posicaoBalao || "acima", // Posição do balão
        };
        
        const confirmRect = {
            id: `confirm-interagir-${node.from.id}`,
            x: posicaoOK.x,
            y: posicaoOK.y,
            text: 'OK',
            visible: true,
            isButton: true,
        };
        
        const newRects = rects.concat(mainRect, confirmRect);
        myStore.dispatch(setRects(newRects));

        // Aguarda resposta do usuário
        let inputValue = '';
        let inputChecked = null;
        
        const inputHandler = (e) => {
            if (e.type === 'inputLer' && e.detail?.rectId === mainRect.id) {
                if (tipoResposta === 'logico') {
                    inputChecked = e.detail.value;
                } else {
                    inputValue = e.detail.value;
                }
            }
        };
        window.addEventListener('inputLer', inputHandler);

        await new Promise((resolve) => {
            const handler = (e) => {
                if (e.type === 'clickConfirm' && e.detail?.rectId === confirmRect.id) {
                    window.removeEventListener('clickConfirm', handler);
                    window.removeEventListener('inputLer', inputHandler);
                    resolve();
                }
            };
            window.addEventListener('clickConfirm', handler);
        });

        // Remove os retângulos após confirmação
        const filteredRects = myStore.getState().rects.rects.filter((r) =>
            ![mainRect.id, confirmRect.id].includes(r.id)
        );
        myStore.dispatch(setRects(filteredRects));

        // Armazena a resposta na variável se especificada
        if (nomeVariavel) {
            const variaveis = myStore.getState().variaveis;
            const variavel = variaveis.find(v => v.nome === nomeVariavel);
            if (variavel) {
                const valor = tipoResposta === 'logico' ? inputChecked : inputValue;
                const index = variaveis.indexOf(variavel);
                myStore.dispatch({ type: 'ATUALIZAR_VARIAVEL', payload: { index, campo: 'valor', valor } });
                console.log(`Variável "${nomeVariavel}" atualizada para:`, valor);
            }
        }
    } else {
        // Se é só uma fala ou pensamento, mostra o balão correspondente
        const rects = myStore.getState().rects.rects;
        const newRect = {
            id: `interagir-balao-${node.from.id}`,
            x: posicao.x,
            y: posicao.y,
            text: mensagem,
            visible: true,
            balloonType: tipoRect, // Define o tipo visual do balão
            balloonPosition: posicaoBalao || "acima", // Posição do balão
        };
        
        const newRects = rects.concat(newRect);
        myStore.dispatch(setRects(newRects));
        
        // Corrige o problema de exibição: usa modo correto baseado na seleção
        if (modoExibicao === "tempo") {
            const ms = (tempoExibicao || 3) * 1000;
            console.log(`Balão ${tipoBalao} será exibido por ${tempoExibicao} segundos`);
            
            // Espera o tempo definido e depois esconde
            await new Promise((res) => setTimeout(res, ms));
            
            // Remove o balão após o tempo
            const filteredRects = myStore.getState().rects.rects.filter(r => 
                r.id !== newRect.id
            );
            myStore.dispatch(setRects(filteredRects));
        } else {
            // Modo "confirmar" - espera clique no OK
            console.log(`Balão ${tipoBalao} aguardando confirmação`);
            
            const confirmRect = {
                id: `confirm-interagir-${node.from.id}`,
                x: posicaoOK.x,
                y: posicaoOK.y,
                text: 'OK',
                visible: true,
                isButton: true,
            };
            
            const rectsWithConfirm = newRects.concat(confirmRect);
            myStore.dispatch(setRects(rectsWithConfirm));

            await new Promise((resolve) => {
                const handler = (e) => {
                    if (e.type === 'clickConfirm' && e.detail?.rectId === confirmRect.id) {
                        window.removeEventListener('clickConfirm', handler);
                        resolve();
                    }
                };
                window.addEventListener('clickConfirm', handler);
            });

            // Remove os retângulos após confirmação
            const filteredRects = myStore.getState().rects.rects.filter((r) =>
                ![newRect.id, confirmRect.id].includes(r.id)
            );
            myStore.dispatch(setRects(filteredRects));
        }
    }
};

export const FundoFunction = async ({ node }) => {
    try {
        const rawUrl = node?.from?.data?.backgroundUrl || '';
        const fit = node?.from?.data?.backgroundFit || 'cover';

        // Permite limpar o fundo ao deixar vazio
        const url = rawUrl ? String(rawUrl) : null;

        // Dispara evento para o Stage aplicar o background
        window.dispatchEvent(
            new CustomEvent('stageBackgroundChanged', {
                detail: { url, fit }
            })
        );
    } catch (error) {
        console.error('Erro ao aplicar Fundo:', error);
    }
};

// Add abort flag and cancel function
let _abortExecution = false;
let _avatarsOriginais = null;
export const cancelExecution = () => { _abortExecution = true; };

// Função para restaurar avatares ao estado original
export const restaurarAvatarsAoEstadoOriginal = () => {
  if (_avatarsOriginais) {
    myStore.dispatch(restaurarAvatarsExecucao(_avatarsOriginais));
    _avatarsOriginais = null;
  }
};

// Função para sincronizar visibilidade dos avatares após importação
export const sincronizarVisibilidadeAvatares = () => {
  console.log("=== SINCRONIZAÇÃO DE AVATARES APÓS IMPORTAÇÃO ===");
  const avatars = myStore.getState().avatars;
  
  avatars.forEach((avatar, index) => {
    // Se tem visivelInicial: true mas visivel: false, corrige
    if (avatar.visivelInicial && !avatar.visivel) {
      console.log(`Sincronizando avatar "${avatar.nome}" (índice ${index}): visivel false -> true`);
      myStore.dispatch(toggleVisibilidadeAvatarExecucao(index, true));
    }
    // Se tem visivelInicial: false mas visivel: true, corrige
    else if (!avatar.visivelInicial && avatar.visivel) {
      console.log(`Sincronizando avatar "${avatar.nome}" (índice ${index}): visivel true -> false`);
      myStore.dispatch(toggleVisibilidadeAvatarExecucao(index, false));
    }
    else {
      console.log(`Avatar "${avatar.nome}" (índice ${index}): já sincronizado (visivel=${avatar.visivel}, visivelInicial=${avatar.visivelInicial})`);
    }
  });
};

// Add execution state flag and functions
export const isExecuting = () => myStore.getState().nodes.isExecuting;
export const setExecutingState = (executing) => { 
    myStore.dispatch(setExecuting(executing)); 
};

export const organizeNodes = async () => {
    // reset abort flag at start
    _abortExecution = false;
    // set execution state using Redux
    myStore.dispatch(setExecuting(true));
    
    // Sincroniza a visibilidade dos avatares com o estado inicial antes de salvar
    const avatarsSincronizados = myStore.getState().avatars.map(avatar => ({
        ...avatar,
        visivel: avatar.visivelInicial // Garante que avatares marcados como visíveis inicialmente apareçam durante execução
    }));
    
    console.log("=== SINCRONIZAÇÃO DE AVATARES NO INÍCIO DA EXECUÇÃO ===");
    
    // Atualiza o estado dos avatares com a sincronização
    avatarsSincronizados.forEach((avatar, index) => {
        const avatarAtual = myStore.getState().avatars[index];
        if (avatar.visivel !== avatarAtual.visivel) {
            console.log(`Sincronizando avatar "${avatar.nome}" (índice ${index}): visivel ${avatarAtual.visivel} -> ${avatar.visivel}`);
            myStore.dispatch(toggleVisibilidadeAvatarExecucao(index, avatar.visivel));
        } else {
            console.log(`Avatar "${avatar.nome}" (índice ${index}): já sincronizado (visivel=${avatar.visivel})`);
        }
    });
    
    // Salva o estado inicial das variáveis
    const variaveisOriginais = JSON.parse(JSON.stringify(myStore.getState().variaveis));
    // Salva o estado inicial dos avatars (após sincronização)
    const avatarsOriginais = JSON.parse(JSON.stringify(myStore.getState().avatars));
    _avatarsOriginais = avatarsOriginais; // Salva na variável global para acesso em cancelExecution
    const nodes = myStore.getState().nodes.nodes;
    const edges = myStore.getState().edges.edges;

    console.log("=================")
    console.log(nodes)

    const orderedNodes = [];

    const nodesMap = nodes.reduce((map, node) => {
        map[node.id] = node;
        return map;
    }, {});

    let currentId = "1";

    try {
        while (currentId) {
            if (_abortExecution) {
                console.log('Execução cancelada!');
                break;
            }
            const currentNode = nodesMap[currentId];
            orderedNodes.push(currentNode);

            const nodeFunction = nodeFunctions[currentNode.data.label];
            
            // Tratamento especial para o nó Repetir
            if (currentNode.data.label === "Repetir" || currentNode.type === "Repetir") {
                console.log('🔄 Encontrado nó Repetir no fluxo principal, executando RepetirFunction');
                await RepetirFunction({
                    node: { from: currentNode },
                    edges
                });
                // Após a execução do RepetirFunction, segue para o próximo nó através do handle "next"
                const nextEdge = edges.find(edge => edge.source === currentId && edge.sourceHandle === 'next');
                currentId = nextEdge ? nextEdge.target : null;
            } else if (nodeFunction) {
                if (currentNode.data.label === "Decidir") {
                    const nextNodeId = await nodeFunction({
                        node: { from: currentNode },
                        edges
                    });
                    console.log("nextNodeId", nextNodeId)
                    currentId = nextNodeId;
                } else {
                    await nodeFunction({
                        node: { from: currentNode },
                        edges
                    });
                    const outgoingEdge = edges.find(
                        (edge) => edge.source === currentId
                    );
                    currentId = outgoingEdge ? outgoingEdge.target : null;
                }
            } else {
                const outgoingEdge = edges.find(
                    (edge) => edge.source === currentId
                );
                currentId = outgoingEdge ? outgoingEdge.target : null;
            }
        }
    } finally {
        // clear execution state using Redux
        myStore.dispatch(setExecuting(false));
        // Restaura o estado original das variáveis após a execução
        const variaveisAtuais = myStore.getState().variaveis;
        if (JSON.stringify(variaveisAtuais) !== JSON.stringify(variaveisOriginais)) {
            variaveisOriginais.forEach((variavel, idx) => {
                myStore.dispatch({ type: 'ATUALIZAR_VARIAVEL', payload: { index: idx, campo: 'valor', valor: variavel.valor } });
            });
        }
        
        // Restaura o estado original dos avatars após a execução
        const avatarsAtuais = myStore.getState().avatars;
        if (JSON.stringify(avatarsAtuais) !== JSON.stringify(avatarsOriginais)) {
            avatarsOriginais.forEach((avatar, idx) => {
                // Restaura a posição original usando ação de execução
                myStore.dispatch(posicionarAvatarExecucao(idx, avatar.x, avatar.y));
                // Restaura a visibilidade original usando ação de execução
                myStore.dispatch(toggleVisibilidadeAvatarExecucao(idx, avatar.visivel));
                // Restaura a rotação original
                myStore.dispatch({
                    type: 'ATUALIZAR_AVATAR',
                    payload: {
                        index: idx,
                        campo: 'rotacao',
                        valor: avatar.rotacao || 0
                    }
                });
            });
        }
        
        // Limpa a variável global após execução completa
        _avatarsOriginais = null;
    }

    if (!_abortExecution) console.log("Execução completa!");
};

// Função para executar um fluxograma importado
export const FluxogramaFunction = async ({ node }) => {
    console.log("=== EXECUTANDO FLUXOGRAMA ===");
    const { fluxogramaData, nomeArquivo, status } = node.from.data;
    
    if (status !== 'carregado' || !fluxogramaData) {
        console.error("Fluxograma não carregado ou inválido");
        return;
    }
    
    console.log(`Executando fluxograma: ${nomeArquivo}`);
    console.log("Dados do fluxograma:", fluxogramaData);
    
    // Salva o estado atual das variáveis e avatares
    const estadoOriginalVariaveis = JSON.parse(JSON.stringify(myStore.getState().variaveis));
    const estadoOriginalAvatares = JSON.parse(JSON.stringify(myStore.getState().avatars));
    
    try {
        // Aplica as variáveis do fluxograma importado temporariamente
        if (fluxogramaData.variables && Array.isArray(fluxogramaData.variables)) {
            console.log("Aplicando variáveis do fluxograma importado:", fluxogramaData.variables);
            myStore.dispatch({ type: 'SET_VARIAVEIS', payload: fluxogramaData.variables });
        }
        
        // Aplica os avatares do fluxograma importado temporariamente
        if (fluxogramaData.avatars && Array.isArray(fluxogramaData.avatars)) {
            console.log("Aplicando avatares do fluxograma importado:", fluxogramaData.avatars);
            myStore.dispatch({ type: 'SET_AVATARS', payload: fluxogramaData.avatars });
        }
        
        // Cria um mapa dos nós do fluxograma importado
        const nodesMap = {};
        if (fluxogramaData.nodes && Array.isArray(fluxogramaData.nodes)) {
            fluxogramaData.nodes.forEach(node => {
                nodesMap[node.id] = node;
            });
        }
        
        // Encontra o nó de início do fluxograma importado
        const startNode = fluxogramaData.nodes.find(node => 
            node.id === "1" || node.type === "Inicio"
        ) || fluxogramaData.nodes[0];
        
        if (!startNode) {
            console.error("Nó de início não encontrado no fluxograma importado");
            return;
        }
        
        console.log("Iniciando execução do fluxograma importado a partir do nó:", startNode.id);
        
        // Executa o fluxograma importado
        let currentId = startNode.id;
        const edges = fluxogramaData.edges || [];
        
        while (currentId) {
            if (_abortExecution) {
                console.log('Execução do fluxograma cancelada!');
                break;
            }
            
            const currentNode = nodesMap[currentId];
            if (!currentNode) {
                console.log("Nó não encontrado:", currentId);
                break;
            }
            
            console.log("Executando nó do fluxograma importado:", currentNode.data.label, currentNode.id);
            
            // Executa a função correspondente ao nó
            const nodeFunction = nodeFunctions[currentNode.data.label];
            if (nodeFunction) {
                if (currentNode.data.label === "Decidir") {
                    const nextNodeId = await nodeFunction({
                        node: { from: currentNode },
                        edges
                    });
                    currentId = nextNodeId;
                } else {
                    await nodeFunction({
                        node: { from: currentNode },
                        edges
                    });
                    const outgoingEdge = edges.find(edge => edge.source === currentId);
                    currentId = outgoingEdge ? outgoingEdge.target : null;
                }
            } else {
                console.log("Função não encontrada para:", currentNode.data.label);
                const outgoingEdge = edges.find(edge => edge.source === currentId);
                currentId = outgoingEdge ? outgoingEdge.target : null;
            }
        }
        
        console.log("Execução do fluxograma importado concluída");
        
    } catch (error) {
        console.error("Erro durante execução do fluxograma:", error);
    } finally {
        // Restaura o estado original das variáveis e avatares
        console.log("Restaurando estado original após execução do fluxograma");
        myStore.dispatch({ type: 'SET_VARIAVEIS', payload: estadoOriginalVariaveis });
        myStore.dispatch({ type: 'SET_AVATARS', payload: estadoOriginalAvatares });
    }
};

export const RepetirFunction = async ({ node, edges }) => {
    try {
        console.log('🔄 Executando RepetirFunction para nó:', node.from.id);
        console.log('📊 Dados do nó completos:', JSON.stringify(node.from.data, null, 2));
        
        // Faz uma cópia dos dados para evitar modificações durante a execução
        const nodeDataSnapshot = JSON.parse(JSON.stringify(node.from.data));
        const { tipoRepeticao, quantidade, dropDataCondicao, variavel, incremento } = nodeDataSnapshot;
        
        // Validações básicas
        if (!tipoRepeticao) {
            console.log('⚠️ Tipo de repetição não definido');
            return;
        }
        
        // Encontra o handle de loop (saída à direita) e o próximo nó normal
        const loopEdge = edges.find(e => e.source === node.from.id && e.sourceHandle === 'loop');
        
        if (!loopEdge) {
            console.log('⚠️ Conexão de loop não encontrada');
            return;
        }
        
        const loopStartNodeId = loopEdge.target;
        const allNodes = myStore.getState().nodes.nodes;
        
        let iterations = 0;
        const maxIterations = 1000; // Proteção contra loops infinitos
        
        if (tipoRepeticao === 'quantidade') {
            // Repetir X vezes - mas se o fluxo voltar, executa novamente
            const numRepeticoes = parseInt(quantidade) || 0;
            console.log(`🔢 Repetindo ${numRepeticoes} vezes`);
            
            let shouldContinue = true;
            while (shouldContinue && iterations < maxIterations) {
                iterations++;
                console.log(`📍 Ciclo ${iterations} do RepetirNode`);
                
                // Executa o bloco numRepeticoes vezes
                for (let i = 0; i < numRepeticoes; i++) {
                    console.log(`📍 Sub-iteração ${i + 1}/${numRepeticoes}`);
                    
                    // Executa o bloco de nós do loop
                    const loopResult = await executeLoopBlock(loopStartNodeId, allNodes, edges, node.from.id);
                    console.log(`✅ Bloco do loop concluído, resultado: ${loopResult}`);
                    
                    // Se deve sair do RepetirNode (acertou), para tudo
                    if (loopResult === 'EXIT_REPEAT') {
                        console.log('� Saindo do RepetirNode - resposta correta!');
                        shouldContinue = false;
                        break;
                    }
                    // Se deve continuar (errou), o executeLoopBlock já retornou CONTINUE_REPEAT
                    // Simplesmente continua a execução
                }
                
                // Após completar as iterações, verifica se deve continuar
                // Se não houve EXIT_REPEAT, significa que deve continuar (errou a resposta)
                if (shouldContinue) {
                    console.log('🔄 Continuando RepetirNode - executando próximo ciclo');
                    // shouldContinue já está true, então continua o while
                }
            }
            
        } else if (tipoRepeticao === 'para') {
            // Loop com contador (para i de inicial até final, passo incremento)
            const { valorFinal } = node.from.data;
            const final = parseInt(valorFinal) || parseInt(quantidade) || 3; // fallback para quantidade se valorFinal não existir
            const passo = parseInt(incremento) || 1;
            
            // Pega o valor inicial da variável existente ou usa 1 como padrão
            let inicial = 1;
            if (variavel) {
                const variavelLimpa = variavel.replace(/[{}]/g, '');
                const variaveis = myStore.getState().variaveis;
                const variavelExistente = variaveis.find(v => v.nome === variavelLimpa);
                if (variavelExistente) {
                    const valorParsed = parseFloat(variavelExistente.valor);
                    if (isNaN(valorParsed)) {
                        console.error(`❌ ERRO: Variável "${variavelLimpa}" tem valor não numérico: "${variavelExistente.valor}"`);
                        // Por enquanto mantenho alert, mas pode ser melhorado para um sistema de notificação global
                        alert(`❌ ERRO DE EXECUÇÃO\n\nA variável "${variavelLimpa}" foi definida com valor "${variavelExistente.valor}" que não é um número válido.\n\nPara usar no loop "Para", a variável precisa ter um valor numérico.\n\nExecução interrompida.`);
                        return;
                    }
                    inicial = valorParsed; // Aceita 0 como valor válido
                    console.log(`📍 Usando valor inicial da variável ${variavelLimpa}: ${inicial}`);
                } else {
                    console.log(`📍 Variável ${variavelLimpa} não encontrada, usando inicial: ${inicial}`);
                    // Cria a variável se não existir
                    updateVariable(variavelLimpa, inicial);
                }
            }
            
            console.log(`🔢 Loop PARA: ${inicial} até ${final}, passo ${passo}`, {
                variavel,
                valorFinal,
                quantidade,
                inicial,
                final,
                passo
            });
            
            for (let i = inicial; passo > 0 ? i <= final : i >= final; i += passo) {
                if (iterations >= maxIterations) break;
                iterations++;
                
                console.log(`📍 Loop PARA: i = ${i}`);
                
                // Atualiza a variável de controle
                if (variavel) {
                    const variavelLimpa = variavel.replace(/[{}]/g, '');
                    
                    // Verifica se a variável ainda existe e tem valor numérico antes de continuar
                    const variaveisAtuais = myStore.getState().variaveis;
                    const variavelAtual = variaveisAtuais.find(v => v.nome === variavelLimpa);
                    
                    if (variavelAtual) {
                        const valorAtual = parseFloat(variavelAtual.valor);
                        if (isNaN(valorAtual)) {
                            console.error(`❌ ERRO: Variável "${variavelLimpa}" foi alterada para valor não numérico durante execução: "${variavelAtual.valor}"`);
                            // Por enquanto mantenho alert, mas pode ser melhorado para um sistema de notificação global
                            alert(`❌ ERRO DE EXECUÇÃO\n\nA variável "${variavelLimpa}" foi alterada para valor "${variavelAtual.valor}" que não é um número válido durante a execução do loop.\n\nPara continuar no loop "Para", a variável precisa manter um valor numérico.\n\nExecução interrompida na iteração ${iterations}.`);
                            return;
                        }
                    }
                    
                    updateVariable(variavelLimpa, i);
                }
                
                // Executa o bloco de nós do loop
                await executeLoopBlock(loopStartNodeId, allNodes, edges, node.from.id);
            }
            
        } else if (tipoRepeticao === 'condicao') {
            // Loop enquanto condição for verdadeira
            console.log(`🔍 Loop ENQUANTO:`, dropDataCondicao);
            
            while (iterations < maxIterations) {
                iterations++;
                
                // Avalia a condição usando o novo formato dropDataCondicao
                const condicaoResult = evaluateDropCondition(dropDataCondicao);
                console.log(`📍 Condição dropData = ${condicaoResult} (iteração ${iterations})`);
                
                if (!condicaoResult) {
                    console.log('🛑 Condição falsa, parando loop');
                    break;
                }
                
                console.log('▶️ Executando bloco do loop...');
                // Executa o bloco de nós do loop
                await executeLoopBlock(loopStartNodeId, allNodes, edges, node.from.id);
                console.log('✅ Bloco do loop concluído');
            }
        }
        
        console.log(`✅ RepetirFunction concluída após ${iterations} iterações`);
        
    } catch (error) {
        console.error('❌ Erro ao executar RepetirFunction:', error);
    }
};

// Função auxiliar para executar um bloco de nós em loop
const executeLoopBlock = async (startNodeId, allNodes, edges, repeatNodeId) => {
    console.log(`🔄 Iniciando executeLoopBlock: startNode=${startNodeId}, repeatNode=${repeatNodeId}`);
    let currentNodeId = startNodeId;
    const visitedInLoop = new Set();
    const maxLoopIterations = 100;
    let loopIterations = 0;
    
    while (currentNodeId && loopIterations < maxLoopIterations) {
        loopIterations++;
        
        console.log(`\n--- LOOP ITERATION ${loopIterations} ---`);
        console.log(`🎯 Current Node ID: ${currentNodeId}`);
        
        const currentNode = allNodes.find(n => n.id === currentNodeId);
        if (!currentNode) {
            console.log(`❌ Nó ${currentNodeId} não encontrado, parando executeLoopBlock`);
            break;
        }
        
        console.log(`🎯 Executando nó: ${currentNodeId} (${currentNode.data.label || currentNode.type})`);
        
        // Se voltou para o nó Repetir, para o loop
        if (currentNodeId === repeatNodeId) {
            console.log('🔄 Voltou para o nó Repetir, parando executeLoopBlock');
            break;
        }
        
        // Se for um nó de fim, para o loop
        if (currentNode.data.label === 'Fim' || currentNode.type === 'Fim') {
            console.log('🏁 Encontrado nó Fim, saindo do RepetirNode');
            return 'EXIT_REPEAT';
        }
        
        // Se for outro nó Repetir, para o loop (evita loops aninhados problemáticos)
        if (currentNode.data.label === 'Repetir' || currentNode.type === 'Repetir') {
            console.log('⚠️ Encontrado outro nó Repetir no bloco, saindo do RepetirNode');
            return 'EXIT_REPEAT';
        }
        
        // Previne loops infinitos dentro do bloco
        if (visitedInLoop.has(currentNodeId)) {
            console.log('⚠️ Loop infinito detectado no bloco de repetição');
            break;
        }
        visitedInLoop.add(currentNodeId);
        
        // Executa a função do nó atual
        const nodeFunction = nodeFunctions[currentNode.data.label];
        let nextNodeId = null;
        
        // Não executa RepetirFunction quando encontrada dentro do executeLoopBlock
        // para evitar loops infinitos - o RepetirFunction já controla seu próprio loop
        if (currentNode.data.label === 'Repetir' || currentNode.type === 'Repetir') {
            console.log('⚠️ Pulando execução de RepetirFunction dentro do executeLoopBlock');
        } else if (nodeFunction) {
            // Para nós de decisão, usa o retorno da função que já calcula o próximo nó corretamente
            if (currentNode.data.label === 'Decidir') {
                nextNodeId = await nodeFunction({ 
                    node: { from: currentNode }, 
                    edges: edges 
                });
                console.log(`🎯 DecidirFunction retornou próximo nó: ${nextNodeId}`);
            } else {
                await nodeFunction({ 
                    node: { from: currentNode }, 
                    edges: edges 
                });
            }
        }
        
        // Se não foi determinado pelo nodeFunction (não é nó de decisão), encontra o próximo nó normalmente
        if (!nextNodeId) {
            const nextEdge = edges.find(e => e.source === currentNodeId);
            nextNodeId = nextEdge ? nextEdge.target : null;
            console.log(`🔗 Próxima edge encontrada: ${currentNodeId} → ${nextNodeId}`);
        }
        
        console.log(`🚀 Próximo nó será: ${nextNodeId}`);
        
        // Se a próxima edge volta para o nó de repetição, sinaliza para continuar o RepetirNode
        if (nextNodeId === repeatNodeId) {
            console.log('🔄 Encontrada edge de volta ao nó Repetir, continuando RepetirNode');
            return 'CONTINUE_REPEAT';
        }
        
        // Se chegou ao fim ou não há próximo nó, para o loop
        if (!nextNodeId) {
            console.log('⚠️ Não há próximo nó, parando executeLoopBlock');
            return 'EXIT_REPEAT';
        }
        
        currentNodeId = nextNodeId;
    }
    
    // Se saiu do loop normalmente, significa que terminou
    return 'EXIT_REPEAT';
};

// Função auxiliar para avaliar condições do formato dropDataCondicao (CustomInputDrop)
const evaluateDropCondition = (dropData) => {
    try {
        if (!dropData) return false;
        
        // Se é um valor direto digitado
        if (!dropData.type && dropData.data?.value) {
            const value = dropData.data.value.trim();
            if (value === '') return false;
            if (value === 'true') return true;
            if (value === 'false') return false;
            
            // Se é um número, considera 0 como false e qualquer outro como true
            const num = parseFloat(value);
            if (!isNaN(num)) return num !== 0;
            
            // Para strings não vazias, retorna true
            return value.length > 0;
        }
        
        // Se é um operador (como OperatorEqualNode, etc.)
        if (dropData.type && dropData.data) {
            return evaluateOperatorCondition(dropData.type, dropData.data);
        }
        
        return false;
        
    } catch (error) {
        console.error('Erro ao avaliar dropCondition:', error);
        return false;
    }
};

// Função auxiliar para avaliar operadores específicos
const evaluateOperatorCondition = (operatorType, operatorData) => {
    try {
        const variaveis = myStore.getState().variaveis;
        
        // Função para resolver valor (variável, literal ou operador aninhado)
        const resolveValue = (val, isVariable = false, variableName = null, nestedOperator = null) => {
            if (!val && !nestedOperator) return '';
            
            // Se é um operador aninhado (como Soma, Subtração, etc.)
            if (nestedOperator && nestedOperator.type) {
                const nestedResult = evaluateNestedOperator(nestedOperator.type, nestedOperator.data);
                console.log(`   🔄 Operador aninhado ${nestedOperator.type} = "${nestedResult}"`);
                return nestedResult;
            }
            
            // Se é uma variável identificada pelos metadados
            if (isVariable && variableName) {
                const variavel = variaveis.find(v => v.nome === variableName);
                return variavel ? variavel.valor : '';
            }
            
            // Se é uma variável no formato {{nome}} (compatibilidade)
            const varMatch = val && val.match ? val.match(/\{\{(.+?)\}\}/) : null;
            if (varMatch) {
                const varName = varMatch[1];
                const variavel = variaveis.find(v => v.nome === varName);
                return variavel ? variavel.valor : '';
            }
            
            // Se é um valor literal
            return val || '';
        };
        
        // Função para avaliar operadores aninhados (Soma, Subtração, etc.)
        const evaluateNestedOperator = (operatorType, operatorData) => {
            try {
                let leftNested, rightNested;
                
                // Para radiciação, usa indexDrop e radicandDrop
                if (operatorType === 'Radiciação' && operatorData.indexDrop && operatorData.radicandDrop) {
                    leftNested = resolveValue(
                        operatorData.indexDrop.data?.value, 
                        operatorData.indexDrop.data?.isVariable, 
                        operatorData.indexDrop.data?.variableName
                    );
                    rightNested = resolveValue(
                        operatorData.radicandDrop.data?.value, 
                        operatorData.radicandDrop.data?.isVariable, 
                        operatorData.radicandDrop.data?.variableName
                    );
                }
                // Para potenciação, usa baseDrop e exponentDrop
                else if (operatorType === 'Potenciação' && operatorData.baseDrop && operatorData.exponentDrop) {
                    leftNested = resolveValue(
                        operatorData.baseDrop.data?.value, 
                        operatorData.baseDrop.data?.isVariable, 
                        operatorData.baseDrop.data?.variableName
                    );
                    rightNested = resolveValue(
                        operatorData.exponentDrop.data?.value, 
                        operatorData.exponentDrop.data?.isVariable, 
                        operatorData.exponentDrop.data?.variableName
                    );
                } else {
                    // Para outros operadores, usa leftDrop e rightDrop
                    leftNested = operatorData.leftDrop ? 
                        resolveValue(
                            operatorData.leftDrop.data?.value, 
                            operatorData.leftDrop.data?.isVariable, 
                            operatorData.leftDrop.data?.variableName
                        ) : '';
                        
                    rightNested = operatorData.rightDrop ? 
                        resolveValue(
                            operatorData.rightDrop.data?.value, 
                            operatorData.rightDrop.data?.isVariable, 
                            operatorData.rightDrop.data?.variableName
                        ) : '';
                }
                
                console.log(`     🧮 ${operatorType}: "${leftNested}" e "${rightNested}"`);
                
                // Converte para números se possível
                const leftNum = parseFloat(leftNested);
                const rightNum = parseFloat(rightNested);
                
                if (isNaN(leftNum) || isNaN(rightNum)) {
                    console.warn(`Operador ${operatorType}: valores não numéricos - left: "${leftNested}", right: "${rightNested}"`);
                    return '';
                }
                
                switch (operatorType) {
                    case 'Soma':
                        return (leftNum + rightNum).toString();
                    case 'Subtração':
                        return (leftNum - rightNum).toString();
                    case 'Multiplicação':
                        return (leftNum * rightNum).toString();
                    case 'Divisão':
                        if (rightNum === 0) {
                            console.warn('Divisão por zero!');
                            return 'Infinity';
                        }
                        return (leftNum / rightNum).toString();
                    case 'Potenciação':
                        return Math.pow(leftNum, rightNum).toString();
                    case 'Radiciação':
                        if (leftNum <= 0) {
                            console.warn('Índice da radiciação deve ser positivo!');
                            return 'NaN';
                        }
                        if (rightNum < 0 && leftNum % 2 === 0) {
                            console.warn('Raiz par de número negativo!');
                            return 'NaN';
                        }
                        return Math.pow(rightNum, 1/leftNum).toString();
                    default:
                        console.warn(`Operador matemático não suportado: ${operatorType}`);
                        return '';
                }
            } catch (error) {
                console.error('Erro ao avaliar operador aninhado:', error);
                return '';
            }
        };
        
        // Suporte para diferentes estruturas de dados do operador
        let leftValue = '';
        let rightValue = '';
        let leftIsVariable = false;
        let rightIsVariable = false;
        let leftVariableName = null;
        let rightVariableName = null;
        let leftNestedOperator = null;
        let rightNestedOperator = null;
        
        // Formato especial para radiciação (indexDrop/radicandDrop)
        if (operatorType === 'Radiciação' && operatorData.indexDrop && operatorData.radicandDrop) {
            // Índice da raiz
            leftValue = operatorData.indexDrop.data?.value || '';
            leftIsVariable = operatorData.indexDrop.data?.isVariable || false;
            leftVariableName = operatorData.indexDrop.data?.variableName || null;
            if (operatorData.indexDrop.type) {
                leftNestedOperator = { type: operatorData.indexDrop.type, data: operatorData.indexDrop.data };
            }
            
            // Radicando
            rightValue = operatorData.radicandDrop.data?.value || '';
            rightIsVariable = operatorData.radicandDrop.data?.isVariable || false;
            rightVariableName = operatorData.radicandDrop.data?.variableName || null;
            if (operatorData.radicandDrop.type) {
                rightNestedOperator = { type: operatorData.radicandDrop.type, data: operatorData.radicandDrop.data };
            }
        }
        // Formato especial para potenciação (baseDrop/exponentDrop)
        else if (operatorType === 'Potenciação' && operatorData.baseDrop && operatorData.exponentDrop) {
            // Base
            leftValue = operatorData.baseDrop.data?.value || '';
            leftIsVariable = operatorData.baseDrop.data?.isVariable || false;
            leftVariableName = operatorData.baseDrop.data?.variableName || null;
            if (operatorData.baseDrop.type) {
                leftNestedOperator = { type: operatorData.baseDrop.type, data: operatorData.baseDrop.data };
            }
            
            // Expoente
            rightValue = operatorData.exponentDrop.data?.value || '';
            rightIsVariable = operatorData.exponentDrop.data?.isVariable || false;
            rightVariableName = operatorData.exponentDrop.data?.variableName || null;
            if (operatorData.exponentDrop.type) {
                rightNestedOperator = { type: operatorData.exponentDrop.type, data: operatorData.exponentDrop.data };
            }
        }
        // Formato novo com leftDrop/rightDrop
        else if (operatorData.leftDrop && operatorData.rightDrop) {
            // Lado esquerdo
            leftValue = operatorData.leftDrop.data?.value || '';
            leftIsVariable = operatorData.leftDrop.data?.isVariable || false;
            leftVariableName = operatorData.leftDrop.data?.variableName || null;
            if (operatorData.leftDrop.type) {
                leftNestedOperator = { type: operatorData.leftDrop.type, data: operatorData.leftDrop.data };
            }
            
            // Lado direito
            rightValue = operatorData.rightDrop.data?.value || '';
            rightIsVariable = operatorData.rightDrop.data?.isVariable || false;
            rightVariableName = operatorData.rightDrop.data?.variableName || null;
            if (operatorData.rightDrop.type) {
                rightNestedOperator = { type: operatorData.rightDrop.type, data: operatorData.rightDrop.data };
            }
        }
        // Formato antigo com left/right
        else if (operatorData.left !== undefined && operatorData.right !== undefined) {
            leftValue = operatorData.left;
            rightValue = operatorData.right;
        }
        
        const left = resolveValue(leftValue, leftIsVariable, leftVariableName, leftNestedOperator);
        const right = resolveValue(rightValue, rightIsVariable, rightVariableName, rightNestedOperator);
        
        console.log(`🔍 Avaliando ${operatorType}: "${left}" com "${right}"`);
        if (leftIsVariable) console.log(`   🟢 Left é variável: {{${leftVariableName}}} = "${left}"`);
        if (rightIsVariable) console.log(`   🟢 Right é variável: {{${rightVariableName}}} = "${right}"`);
        if (leftNestedOperator) console.log(`   🔄 Left é operador: ${leftNestedOperator.type}`);
        if (rightNestedOperator) console.log(`   🔄 Right é operador: ${rightNestedOperator.type}`);
        
        console.log(`🔍 Avaliando operador: "${operatorType}" com left="${left}" e right="${right}"`);
        
        switch (operatorType) {
            case 'Igual a':
            case 'OperatorEqual': {
                const equalResult = left == right;
                console.log(`✅ Igual a: ${left} == ${right} = ${equalResult}`);
                return equalResult;
            }
            case 'Diferente de':
            case 'Diferente':
            case 'OperatorNotEqual': {
                const notEqualResult = left != right;
                console.log(`❌ Diferente de: ${left} != ${right} = ${notEqualResult}`);
                return notEqualResult;
            }
            case 'Maior que':
            case 'OperatorGreater': {
                const leftNum = parseFloat(left);
                const rightNum = parseFloat(right);
                if (!isNaN(leftNum) && !isNaN(rightNum)) {
                    return leftNum > rightNum;
                }
                return left > right; // Comparação de string
            }
            case 'Menor que':
            case 'OperatorLess': {
                const leftNum2 = parseFloat(left);
                const rightNum2 = parseFloat(right);
                if (!isNaN(leftNum2) && !isNaN(rightNum2)) {
                    return leftNum2 < rightNum2;
                }
                return left < right; // Comparação de string
            }
            case 'Maior ou igual':
            case 'Maior ou igual a':
            case 'OperatorGreaterEqual': {
                const leftNum3 = parseFloat(left);
                const rightNum3 = parseFloat(right);
                if (!isNaN(leftNum3) && !isNaN(rightNum3)) {
                    return leftNum3 >= rightNum3;
                }
                return left >= right;
            }
            case 'Menor ou igual':
            case 'Menor ou igual a':
            case 'OperatorLessEqual': {
                const leftNum4 = parseFloat(left);
                const rightNum4 = parseFloat(right);
                if (!isNaN(leftNum4) && !isNaN(rightNum4)) {
                    return leftNum4 <= rightNum4;
                }
                return left <= right;
            }
            default:
                console.warn(`Operador não suportado: ${operatorType}`);
                return false;
        }
        
    } catch (error) {
        console.error('Erro ao avaliar operador:', error);
        return false;
    }
};

// Função auxiliar para atualizar variáveis
const updateVariable = (name, value) => {
    try {
        const variaveis = myStore.getState().variaveis;
        
        // Verifica se variaveis é um array
        if (!Array.isArray(variaveis)) {
            console.error('Estado variaveis não é um array:', variaveis);
            return;
        }
        
        // Procura a variável existente
        const existingIndex = variaveis.findIndex(v => v.nome === name);
        
        if (existingIndex >= 0) {
            // Atualiza variável existente
            myStore.dispatch({ 
                type: 'ATUALIZAR_VARIAVEL', 
                payload: { 
                    index: existingIndex, 
                    campo: 'valor', 
                    valor: value 
                } 
            });
            console.log(`✅ Variável "${name}" atualizada para: ${value}`);
        } else {
            // Cria nova variável
            const novasVariaveis = [...variaveis, { nome: name, valor: value }];
            myStore.dispatch({ type: 'SET_VARIAVEIS', payload: novasVariaveis });
            console.log(`✅ Nova variável "${name}" criada com valor: ${value}`);
        }
    } catch (error) {
        console.error('Erro ao atualizar variável:', error);
    }
};

export const nodeFunctions = {
    Esperar: EsperarFunction,
    Mostrar: MostrarFunction,
    Decidir: DecidirFunction,
    Ler: LerFunction,
    Atribuir: AtribuirFunction,
    Fundo: FundoFunction,
    "Visível": AvatarVisivelFunction,
    "Posicionar": AvatarPosicionarFunction,
    "Interagir Avatar": InteragirAvatarFunction,
    "Virar": VirarFunction,
    "Fluxograma": FluxogramaFunction,
    // "Repetir": RepetirFunction  // Comentado temporariamente - o RepetirNode controla sua própria execução
};
